import { useState, useEffect, createContext, useContext } from "react";
import { apiCall } from "../api";

// Auth Context
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);
  const [isGuestMode, setIsGuestMode] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser && token) {
      setUser(JSON.parse(savedUser));
      // Refresh verification status / admin flag, which may have changed since the last login
      apiCall('/auth/me', 'GET', null, token)
        .then((fresh) => {
          setUser(fresh);
          localStorage.setItem('user', JSON.stringify(fresh));
        })
        .catch(() => {});
    }
    setLoading(false);
  }, [token]);

  const updateUser = (changes) => {
    setUser((prev) => {
      const next = { ...prev, ...changes };
      localStorage.setItem('user', JSON.stringify(next));
      return next;
    });
  };

  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    setIsGuestMode(false);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', authToken);
  };

  const startGuestMode = () => {
    setIsGuestMode(true);
    setUser(null);
    setToken(null);
  };

  const exitGuestMode = () => setIsGuestMode(false);

  const logout = () => {
    setUser(null);
    setToken(null);
    setIsGuestMode(false);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, isGuestMode, startGuestMode, exitGuestMode, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export { AuthContext, AuthProvider, useAuth };
